(function (window, document, $) {
	"use strict";

	var $navWrapper = $(".jh-sticky-nav-wrapper");

	// Exit if no nav wrapper or menu is already populated.
	if (!$navWrapper.length || ($(".jh-sticky-nav ul").html() || "").trim().length) {
		return;
	}

	// ── Constants ─────────────────────────────────────────────────────────────
	var ACTIVE_CLASS = "active";
	var FIXED_CLASS = "fixed";
	var SCROLL_DURATION = 600; // ms

	// ── State ─────────────────────────────────────────────────────────────────
	var navEl = $navWrapper[0];
	var $menu = $navWrapper.find(".jh-sticky-nav ul");
	var $anchorTargets = $('[data-sticky-nav-include="true"]');
	var $footer = $("footer").length ? $("footer") : $(".site-footer");
	var hasTabulaStickyHeader = !!document.querySelector(".tabula-sticky-header");
	// True while a click-triggered scroll animation is running.
	// Prevents the scroll-spy from overwriting the manually-set active item.
	var isProgrammaticScroll = false;
	var rafId = null;
	var resizeRafId = null;
	var tabulaStickyNavVisibleClass = "tabula-sticky-nav-visible";
	var tabulaStickyNavResetClass = "tabula-sticky-nav-reset";
	var tabulaStickyNavFadeId = null;

	// ── Helpers ───────────────────────────────────────────────────────────────

	function isFixedOrSticky(el) {
		if (!el) {
			return false;
		}

		var style = window.getComputedStyle(el);
		return style.position === "fixed" || style.position === "sticky";
	}

	function getStickyElementBottom(el) {
		if (!isFixedOrSticky(el) || !el.getClientRects().length) {
			return 0;
		}

		return Math.max(0, Math.ceil(el.getBoundingClientRect().bottom));
	}

	// Measure every active sticky element that sits above the secondary nav.
	// Returns the pixel value to expose as the CSS sticky top offset.
	function getStickyTop() {
		var top = 0;

		// WordPress admin bar (logged-in users)
		// On mobile (<600px) WP sets the admin bar to position:static, so only
		// count it when it is actually in the fixed stack.
		var adminBar = document.getElementById("wpadminbar");
		top = Math.max(top, getStickyElementBottom(adminBar));

		// Main site navbar - look for any fixed/sticky element above us.
		// The primary nav uses #masthead or .site-header on this theme.
		var mainNav = document.getElementById("masthead") ||
			document.querySelector(".site-header") ||
			document.querySelector(".navbar");
		top = Math.max(top, getStickyElementBottom(mainNav));

		var tabulaHeader = document.querySelector(".tabula-sticky-header.tabula-sticky-header--visible");
		top = Math.max(top, getStickyElementBottom(tabulaHeader));

		return top;
	}

	function updateStickyOffset() {
		var stickyTop = getStickyTop();
		document.documentElement.style.setProperty("--jh-sticky-nav-top", stickyTop + "px");
		navEl.style.removeProperty("top");

		return stickyTop;
	}

	function cancelTabulaStickyNavFade() {
		if (tabulaStickyNavFadeId) {
			window.cancelAnimationFrame(tabulaStickyNavFadeId);
			tabulaStickyNavFadeId = null;
		}
	}

	function setStickyNavHiddenForAssistiveTech(shouldHide) {
		if (shouldHide) {
			$navWrapper.attr("aria-hidden", "true");
			navEl.setAttribute("inert", "");
			return;
		}

		$navWrapper.removeAttr("aria-hidden");
		navEl.removeAttribute("inert");
	}

	function setTabulaStickyNavVisible(shouldShow) {
		if (!shouldShow) {
			cancelTabulaStickyNavFade();
			$navWrapper.removeClass(tabulaStickyNavVisibleClass);
			$navWrapper.removeClass(tabulaStickyNavResetClass);
			return;
		}

		if ($navWrapper.hasClass(tabulaStickyNavVisibleClass) || tabulaStickyNavFadeId) {
			return;
		}

		$navWrapper.removeClass(tabulaStickyNavVisibleClass);
		$navWrapper.addClass(tabulaStickyNavResetClass);
		setStickyNavHiddenForAssistiveTech(true);
		tabulaStickyNavFadeId = window.requestAnimationFrame(function () {
			tabulaStickyNavFadeId = window.requestAnimationFrame(function () {
				tabulaStickyNavFadeId = null;
				$navWrapper.removeClass(tabulaStickyNavResetClass);
				$navWrapper.addClass(tabulaStickyNavVisibleClass);
				if (!$navWrapper.hasClass("nav-hidden")) {
					setStickyNavHiddenForAssistiveTech(false);
				}
			});
		});
	}

	// Measure distance from nav's bottom edge to footer's top edge.
	// Returns pixels; 0 or negative means they're overlapping.
	// navRect is passed in to avoid redundant getBoundingClientRect() calls.
	function getFooterDistance(navRect) {
		if (!$footer.length) {
			return Infinity; // No footer, plenty of space
		}
		var navBottom = navRect.bottom;
		var footerTop = $footer[0].getBoundingClientRect().top;
		return footerTop - navBottom;
	}

	// Total pixels from the top of the viewport to the "reading line"
	// (below the sticky nav). When fixed, getBoundingClientRect().bottom gives
	// the exact pixel where the nav stops covering content.
	function getStickyOffset() {
		var stickyTop = updateStickyOffset();
		var navRect = navEl.getBoundingClientRect();
		var isStuck = navRect.top <= stickyTop + 1;
		if (isStuck) {
			return Math.round(navEl.getBoundingClientRect().bottom);
		}
		return $navWrapper.outerHeight() + stickyTop;
	}

	// ── Build nav items from data-sticky-nav-include elements ─────────────────

	$anchorTargets.each(function () {
		var $el = $(this);
		function sl_translate() { } // Smartling Empty Function
		var sl_tr_start = sl_translate; // Smartling start translation
		var label = $el.data("sticky-nav-label");
		var sl_tr_end = sl_translate; // Smartling end translation
		var id = $el.attr("id");

		if (!id && !label) {
			return;
		}

		if (!id) {
			id = String(label).toLowerCase().replace(/[^\w ]+/g, "").replace(/ +/g, "-");
			$el.attr("id", id);
		}

		var $menuItem = $("<li>").addClass("sticky-nav-item list-group-item mb-0");
		var $menuLink = $("<a>")
			.attr("id", id + "ProductNav")
			.attr("href", "#" + id)
			.text(label);

		$menuItem.append($menuLink);
		$menu.append($menuItem);
	});

	// ── Active-state helpers ──────────────────────────────────────────────────

	function setActive(id) {
		// Remove active class and aria-current from all items
		$menu.find("." + ACTIVE_CLASS).removeClass(ACTIVE_CLASS).find("a").removeAttr("aria-current");
		if (id) {
			var $activeLink = $menu.find('a[href="#' + id + '"]');
			$activeLink.parent().addClass(ACTIVE_CLASS);
			// Announce active state to screen readers (WCAG 4.1.2)
			$activeLink.attr("aria-current", "page");
		}
	}

	// Returns the id of whichever anchor section the viewport is currently in.
	// "Current section" = the last anchor whose top is at or above the reading line.
	function computeActiveId() {
		var readingLine = window.pageYOffset + getStickyOffset() + 2;
		var activeId = null;

		$anchorTargets.each(function () {
			if ($(this).offset().top <= readingLine) {
				activeId = this.id;
			}
		});

		// If we haven't scrolled past any anchor yet, default to the first.
		if (!activeId && $anchorTargets.length) {
			activeId = $anchorTargets.first().attr("id");
		}

		return activeId;
	}

	// ── Fixed-position helpers ────────────────────────────────────────────────

	function updateFixedState() {
		var stickyTop = updateStickyOffset();
		var isTabulaStickyHeaderVisible = !!document.querySelector(".tabula-sticky-header.tabula-sticky-header--visible");

		// Cache navRect to avoid calling getBoundingClientRect() twice.
		var navRect = navEl.getBoundingClientRect();
		var shouldFix = navRect.top <= stickyTop + 1;

		// Use addClass/removeClass directly since we know the desired state
		if (shouldFix) {
			$navWrapper.addClass(FIXED_CLASS);
		} else {
			$navWrapper.removeClass(FIXED_CLASS);
		}

		$navWrapper.toggleClass("has-tabula-sticky-header", hasTabulaStickyHeader);
		setTabulaStickyNavVisible(hasTabulaStickyHeader && shouldFix && isTabulaStickyHeaderVisible);

		// Hide the nav if it would overlap the footer (when distance <= 0)
		var footerDistance = getFooterDistance(navRect);
		var shouldHide = footerDistance <= 0;

		// Use addClass/removeClass directly since we know the desired state
		if (shouldHide) {
			$navWrapper.addClass("nav-hidden");
		} else {
			$navWrapper.removeClass("nav-hidden");
		}

		setStickyNavHiddenForAssistiveTech(
			shouldHide ||
			(
				hasTabulaStickyHeader &&
				shouldFix &&
				(!isTabulaStickyHeaderVisible || $navWrapper.hasClass(tabulaStickyNavResetClass))
			)
		);
	}

	// ── Click handler (scroll + active) ──────────────────────────────────────
	// Single unified handler — replaces the original two separate click bindings
	// (initMenuItems + pageSmoothScroll) that would fight each other.

	$menu.on("click", "a", function (e) {
		e.preventDefault();

		var href = $(this).attr("href");
		var targetId = href.slice(1);
		var $target = $(href);

		if (!$target.length) {
			return;
		}

		// Analytics
		if (window.gtmHelper) {
			var label = $(this).text();
			if (typeof gtmHelper.inPageInteractionTrack === "function") {
				gtmHelper.inPageInteractionTrack(label, "Sticky Navigation");
			} else if (typeof gtmHelper.inPageInteractionEvent === "function") {
				gtmHelper.inPageInteractionEvent(label, "Sticky Navigation");
			}
		}

		// Set active immediately — isProgrammaticScroll prevents scroll-spy from
		// overwriting this state while the animation plays out.
		setActive(targetId);
		isProgrammaticScroll = true;

		var targetScrollTop = $target.offset().top - getStickyOffset();

		// $("html, body").animate() fires the callback twice (once per element),
		// so guard with a once-flag.
		var animDone = false;
		$("html, body").stop(true).animate({ scrollTop: targetScrollTop }, SCROLL_DURATION, function () {
			if (animDone) {
				return;
			}
			animDone = true;
			isProgrammaticScroll = false;
			setActive(targetId); // Re-confirm after animation settles

			// Accessibility: move focus to the target section.
			if (!$target.attr("tabindex")) {
				$target.attr("tabindex", "-1");
				// Remove tabindex once element loses focus to prevent keyboard traps (WCAG 2.1.2)
				$target.one("blur", function () {
					$(this).removeAttr("tabindex");
				});
			}
			$target.focus();
		});
	});

	// ── Scroll + resize handlers (throttled via rAF) ──────────────────────────

	$(window).on("scroll.stickyNav", function () {
		if (rafId) {
			return;
		}
		rafId = window.requestAnimationFrame(function () {
			updateFixedState();
			if (!isProgrammaticScroll) {
				setActive(computeActiveId());
			}
			rafId = null;
		});
	});

	$(window).on("resize.stickyNav", function () {
		if (resizeRafId) {
			return;
		}

		resizeRafId = window.requestAnimationFrame(function () {
			updateFixedState();
			if (!isProgrammaticScroll) {
				setActive(computeActiveId());
			}
			resizeRafId = null;
		});
	});

	$(window).on("tabulaStickyHeaderChange.stickyNav", function () {
		updateFixedState();
	});

	// ── Initialise ────────────────────────────────────────────────────────────

	updateFixedState();
	setActive(computeActiveId());

})(window, document, jQuery);
